import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrinter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPrinter2"><Path fillRule="evenodd" clipRule="evenodd" d="M14.5 8C15.8807 8 17 9.11929 17 10.5V18.5C17 19.8807 15.8807 21 14.5 21H9.5C8.11929 21 7 19.8807 7 18.5V10.5C7 9.11929 8.11929 8 9.5 8H14.5ZM10 16H12.5V15H10V16ZM10 12H14V11H10V12Z" fill="currentColor"/><Path d="M19 3C20.6569 3 22 4.34315 22 6V9C22 10.6569 20.6569 12 19 12H18V10.5C18 8.567 16.433 7 14.5 7H9.5C7.567 7 6 8.567 6 10.5V12H5C3.34315 12 2 10.6569 2 9V6C2 4.34315 3.34315 3 5 3H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrinter2;
